<div class="ib-digital-menu-mmb__menu-list--option">
    <span *ngFor="let description of item.description" class="ib-digital-menu-mmb__menu-list--option__name">
        {{description}}
    </span>
    <div *ngIf="!showAllergenDisclamer()" class="ib-digital-menu-mmb__menu-list--option__allergens-container">
        <div class="ib-digital-menu-mmb__menu-list--option__allergens" *ngFor="let allergen of item.allergens">
            <img [src]="alergensIconUrl+allergen.code + '.png'" [alt]="allergen.name | translate"
                [title]="allergen.name | translate">
        </div>
    </div>
    <div *ngIf="showAllergenDisclamer()" class="ib-digital-menu-mmb__menu-list--option__allergens">
        <span>
            {{item.allergens[0].name}}
        </span>
    </div>
</div>
